import "./ModalBSBody.scss";

function ModalBSBody({ children, className }) {
  return (
    <div 
      className={`modal-body ${className}`}
      style={{
        maxHeight: "calc(100vh - 200px)",
        overflowY: "auto",
        padding: "1rem"
      }}
    >
      {children}
    </div>
  );
}

export default ModalBSBody;
